/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EditarUsuarioDto } from '../../models/editar-usuario-dto';

export interface DoctoresPacientesControllerActualizarPaciente$Params {

/**
 * UUID del paciente a actualizar
 */
  uuidPaciente: string;
      body: EditarUsuarioDto
}

export function doctoresPacientesControllerActualizarPaciente(http: HttpClient, rootUrl: string, params: DoctoresPacientesControllerActualizarPaciente$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, doctoresPacientesControllerActualizarPaciente.PATH, 'put');
  if (params) {
    rb.path('uuidPaciente', params.uuidPaciente, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

doctoresPacientesControllerActualizarPaciente.PATH = '/api/doctor-pacientes/actualizar-paciente/{uuidPaciente}';
